import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class GrnApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.GRN);
  }

  getGRNLines(grnId) {
    return this.httpClient.get(`${this.getResourceUrl()}${grnId}/lines/`);
  }

  addGRNLines(grnId, data) {
    return this.httpClient.post(
      `${this.getResourceUrl()}${grnId}/lines/multi-add/`,
      data,
    );
  }

  deleteGRNLines(grnId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${grnId}/lines/multi-remove/`,
      data,
    );
  }

  updateGRNStatus(grnId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${grnId}/status/`,
      data,
    );
  }

  getGRNPutaway(warehouseId) {
    return this.httpClient.get(
      `${this.getResourceUrl()}put-away/${warehouseId}/`,
    );
  }

  updateGRNLinesShelf(grnId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${grnId}/lines/categories/`,
      data,
    );
  }
}

export default new GrnApi();
